import React, { useEffect, useState } from "react";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import FieldFormatSelection from "../../../components/BuilderComponents/FieldFormateSelection";
import SingleJobPopup from "../../../components/BuilderComponents/JobConfigration/SingleJobPopup";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import Input from "../../../components/FormComponents/Input";
import Label from "../../../components/FormComponents/Label";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Textarea from "../../../components/FormComponents/Textarea";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useModalContext } from "../../../context/ModalContext";
import { useParams } from "react-router-dom";
import { toastError } from "../../../utils/toastUtils";

const EditChartConfig = ({ editRightsideBar, allTableColumns, saveChartConfig, tableId, activityId = "" }) => {
  const [chartConfig, setChartConfig] = useState({});
  const [currentTab, setCurrentTab] = useState(0);
  const [allJobs, setAllJobs] = useState([]);

  const fetchAllTemplatesAndJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=chart_tabular_cell`);

      setAllJobs(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    setChartConfig(editRightsideBar.config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editRightsideBar.id]);

  useEffect(() => {
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editRightsideBar.id]);

  useEffect(() => {
    saveChartConfig(chartConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartConfig]);
  return (
    <>
      <div className="sidebar_tab_buttons ">
        {["Label", "Data", "Style"].map((name, i) => (
          <div
            className={i === currentTab ? "active sidebar_tabs" : "sidebar_tabs"}
            key={name}
            onClick={() => setCurrentTab(i)}
          >
            {name}
          </div>
        ))}
      </div>
      <div className="charts_sidebar_outer">
        {currentTab === 0 && <EditChartLabel chartConfig={chartConfig} setChartConfig={setChartConfig} />}
        {currentTab === 1 && (
          <EditChartData
            chartConfig={chartConfig}
            setChartConfig={setChartConfig}
            allTableColumns={allTableColumns}
            tableId={tableId}
            activityId={activityId}
            allJobs={allJobs}
          />
        )}
        {currentTab === 2 && <EditChartStyles chartConfig={chartConfig} setChartConfig={setChartConfig} />}
      </div>
    </>
  );
};

const EditChartLabel = ({ chartConfig, setChartConfig }) => {
  const { orgId } = useParams();

  const { getUserConfirmation } = useModalContext();
  const [templates, setTemplates] = useState([]);

  const handleCheckbox = (e) => {
    setChartConfig({ ...chartConfig, [e.target.name]: e.target.checked });
  };

  const handleInputChange = (e) => {
    setChartConfig({ ...chartConfig, [e.target.name]: e.target.value });
  };

  const handleTemplateChange = (id) => {
    setChartConfig({ ...chartConfig, chart_template_id: id });
  };

  const handleTypeChange = async (value, type) => {
    const userConfirmed = await getUserConfirmation("You want to change <strong>Chart Type</strong>");
    if (!userConfirmed) return;
    setChartConfig({ ...chartConfig, chart_type: value, type: type });
    // onClose()
  };

  const getChartTemplates = async () => {
    const { data } = await axiosInstance.get(`/sysconfigs/org/${orgId}/type/chart_template`);

    const templates = data
      .filter((template) => template.name.length > 0)
      .map((template) => ({ id: template.id, name: template.name }));

    return templates;
  };

  useEffect(() => {
    getChartTemplates().then((templates) => setTemplates(templates));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const convertFields = {
    "line/2d": ["bar", "pie", "table", "spark_line", "spark_area", "spark_pie", "spark_column", "donut"],
    "bar/2d": ["line", "pie", "table", "spark_line", "spark_area", "spark_pie", "spark_column", "donut"],
    "pie/2d": ["line", "bar", "table", "spark_line", "spark_area", "spark_pie", "spark_column", "donut"],
    "table/2d": ["line", "bar", "pie", "spark_line", "spark_area", "spark_pie", "spark_column", "donut"],
    "spark_line/2d": ["line", "bar", "pie", "table", "spark_area", "spark_pie", "spark_column", "donut"],
    "spark_area/2d": ["line", "bar", "pie", "table", "spark_line", "spark_pie", "spark_column", "donut"],
    "spark_pie/2d": ["line", "bar", "pie", "table", "spark_line", "spark_area", "spark_column", "donut"],
    "spark_column/2d": ["line", "bar", "pie", "table", "spark_line", "spark_area", "spark_pie", "donut"],
    "donut/2d": ["line", "bar", "pie", "table", "spark_line", "spark_area", "spark_pie", "spark_column"],

    "line/3d": ["bar", "table"],
    "bar/3d": ["line", "table"],
    "table/3d": ["bar", "line"]
  };
  const handleChangeAllowFilter = (e) => {
    setChartConfig({ ...chartConfig, [e.target.name]: e.target.checked });
  };
  const convertChartOptions = () => {
    const chartKey = chartConfig.chart_type + "/" + chartConfig.type;

    const convertFieldsOptions =
      (chartConfig?.chart_type &&
        convertFields[chartKey]?.map((field) => ({ id: field, name: field, type: chartConfig.type }))) ||
      [];
    return convertFieldsOptions;
  };
  return (
    <div className="builder_form mt_3">
      <Input
        type="text"
        value={chartConfig.title}
        name="title"
        placeholder="Enter Title of Chart"
        onChange={(e) => handleInputChange(e)}
        label="Chart Title"
      />
      {chartConfig.chart_type !== "table" && (
        <Input
          type="text"
          value={chartConfig.sub_title}
          name="sub_title"
          placeholder="Enter Sub Title of Chart"
          onChange={(e) => handleInputChange(e)}
          label="Chart Sub Title"
        />
      )}
      {chartConfig.chart_type !== "pie" && (
        <>
          <Input
            type="text"
            value={chartConfig.xaxis_title}
            name="xaxis_title"
            placeholder={chartConfig.chart_type === "table" ? "Enter Label" : "Enter X-Axis Title"}
            onChange={(e) => handleInputChange(e)}
            label={chartConfig.chart_type === "table" ? "Label" : "Chart X-Axis Label"}
          />

          <Input
            type="text"
            value={chartConfig.yaxis_title}
            name="yaxis_title"
            placeholder={chartConfig.chart_type === "table" ? "Enter Value" : "Enter Y-Axis Title"}
            onChange={(e) => handleInputChange(e)}
            label={chartConfig.chart_type === "table" ? "Value" : "Chart Y-Data Value"}
          />
        </>
      )}
      {chartConfig.type === "2d" && chartConfig.chart_type !== "table" && (
        <Input
          type="text"
          value={chartConfig.data_label}
          name="data_label"
          placeholder="Enter Data Label"
          onChange={(e) => handleInputChange(e)}
          label="Chart Data Label"
        />
      )}
      <Input
        type="checkbox"
        label="Allow Filter"
        checked={chartConfig.chart_filter}
        name="chart_filter"
        onChange={handleChangeAllowFilter}
      />
      <Input
        type="checkbox"
        label="Show Legend Count"
        name="show_legend_count"
        checked={chartConfig.show_legend_count}
        onChange={handleChangeAllowFilter}
      />
      {chartConfig.chart_type !== "pie" && chartConfig.chart_type !== "table" && (
        <Input
          type="checkbox"
          style={{ marginBottom: "0px" }}
          checked={chartConfig.axis_inverted}
          name="axis_inverted"
          onChange={handleCheckbox}
          label="Axis Inverted"
        />
      )}
      <SingleSelectBox
        selectedData=""
        options={convertChartOptions()}
        onChange={(obj) => handleTypeChange(obj.id, obj.type)}
        placeholder="Select field"
        label="Convert Chart"
        isSearch={true}
      />

      <SingleSelectBox
        selectedData={chartConfig?.chart_template_id || ""}
        options={templates}
        onChange={(data) => handleTemplateChange(data.id)}
        placeholder="Select Template"
        label="Choose Template"
        isSearch={true}
      />
    </div>
  );
};

const EditChartData = ({ chartConfig, setChartConfig, allTableColumns, tableId, allJobs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { applicationBlockData } = useAppBlocksContext();
  const templateObject = {};

  const handleJobTriggerData = (data) => {
    const newChartConfig = { ...chartConfig };
    newChartConfig.add_event_config = data;
    setChartConfig(newChartConfig);
    // setJobOpen(false);
  };

  const handleInputChange = (name, value) => {
    setChartConfig({ ...chartConfig, [name]: value });
  };

  const renderGroupColumn = (index) => {
    return (
      <div onClick={() => setIsModalOpen(`group.${index}`)}>
        {!chartConfig.group_columns[index]?.column
          ? "No field assign"
          : (allTableColumns[chartConfig.group_columns[index]?.column]?.activity_label || "") +
              "." +
              allTableColumns[chartConfig.group_columns[index]?.column]?.display || ""}
      </div>
    );
  };

  const renderDateSelect = (index) => {
    const dateGroupOptions = [
      { id: "day", name: "Day" },
      { id: "week", name: "Week" },
      { id: "month", name: "Month" },
      { id: "year", name: "Year" }
    ];
    return Object.values(allTableColumns)
      .filter((col) => col.data_key === chartConfig.group_columns[index]?.column || "")
      .map((field) => {
        return (
          <div key={field.id}>
            {(field.data_type === "time" || field.data_type === "date" || field.data_type === "datetime") && (
              <SingleSelectBox
                selectedData={chartConfig.group_columns[index].date_group}
                options={dateGroupOptions}
                onChange={(obj) => handleChangeDateGroup(obj.id, index)}
                placeholder="none"
              />
            )}
          </div>
        );
      });
  };

  const handleChangeDateGroup = (value, index) => {
    const copyObj = JSON.parse(JSON.stringify(chartConfig));
    copyObj.group_columns[index].date_group = value;
    setChartConfig(copyObj);
  };

  const callbackFunction = (data) => {
    const [type, index] = isModalOpen.split(".");
    if (type === "aggregate") {
      setChartConfig({ ...chartConfig, aggregate_column: data.id });
    }
    if (type === "group") {
      const copyObj = JSON.parse(JSON.stringify(chartConfig));
      const obj = {
        column: data.id,
        date_group: ""
      };

      let allReadyExist = false;

      chartConfig.group_columns.forEach((field) => {
        if (field.column === data.id) {
          allReadyExist = true;
          return;
        }
      });
      if (allReadyExist) {
        toastError("Allready exists");
        return;
      }

      copyObj.group_columns[index] = obj;
      setChartConfig(copyObj);
    }
    setIsModalOpen(false);
  };

  const aggregateFunctionOptions = [
    { id: "avg", name: "avg" },
    { id: "sum", name: "sum" },
    { id: "count", name: "count" }
  ];
  const chartOptions = [
    { id: "avg", name: "avg" },
    { id: "sum", name: "sum" }
  ];
  return (
    <div className="builder_form mt_3">
      <Label>Group Column</Label>
      <div className="builder_input d_flex justify_center">
        <div>
          {renderGroupColumn(0)}
          {renderDateSelect(0)}
        </div>
      </div>
      {chartConfig.dimension === "3d" && (
        <div className="builder_input d_flex justify_center">
          <div>
            {renderGroupColumn(1)}
            {renderDateSelect(1)}
          </div>
        </div>
      )}

      <div className="builder_form">
        <Label>Aggregate Column</Label>
        <div className="builder_input d_flex justify_center" onClick={() => setIsModalOpen("aggregate.none")}>
          <div>
            {chartConfig.aggregate_column === ""
              ? "No field assign"
              : (allTableColumns[chartConfig.aggregate_column]?.prefix || "") +
                  "." +
                  allTableColumns[chartConfig.aggregate_column]?.display || ""}
          </div>
        </div>

        <SingleSelectBox
          selectedData={chartConfig.aggregate_function}
          options={aggregateFunctionOptions}
          onChange={(obj) => handleInputChange("aggregate_function", obj.id)}
          label="Aggregate Function"
          placeholder="select"
        />

        {(chartConfig.chart_type === "spark_line" ||
          chartConfig.chart_type === "spark_area" ||
          chartConfig.chart_type === "spark_pie" ||
          chartConfig.chart_type === "spark_column") && (
          <>
            <SingleSelectBox
              selectedData={chartConfig.tile_aggregate_function}
              options={chartOptions}
              onChange={(obj) => handleInputChange("tile_aggregate_function", obj.id)}
              label="Tile Aggregate Function"
              placeholder="select"
            />
          </>
        )}

        <FieldFormatSelection
          type="number"
          value={chartConfig.number_format || ""}
          onChange={(id) => handleInputChange("number_format", id)}
        />
        <FieldFormatSelection
          type="currency"
          value={chartConfig.currency_code || ""}
          onChange={(id) => handleInputChange("currency_code", id)}
          label="Currency Format"
        />

        <SingleJobPopup
          config={chartConfig.add_event_config}
          templateObject={templateObject}
          allJobs={allJobs}
          smId={tableId}
          device={applicationBlockData.device}
          onChange={handleJobTriggerData}
          label="Job"
        />
      </div>
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName={"Add Filter"}>
        <TableTreeModal
          callbackFunction={callbackFunction}
          tableId={tableId}
          selectedFile={
            typeof isModalOpen === "string"
              ? isModalOpen.startsWith("aggregate")
                ? chartConfig?.aggregate_column
                : isModalOpen.startsWith("group")
                  ? chartConfig?.group_columns?.[isModalOpen.split(".")[1]]?.column || ""
                  : ""
              : ""
          }
        />
      </BuilderModal>
    </div>
  );
};

const EditChartStyles = ({ chartConfig, setChartConfig }) => {
  const [chartStylesConfig, setChartStylesConfig] = useState(JSON.stringify(chartConfig.chart_styles || {}, null, 2));
  const [jsonError, setJsonError] = useState("");

  const handleChangePivotConfig = (e) => {
    const value = e.target.value;
    setChartStylesConfig(value);
    try {
      const parsedValue = JSON.parse(value);
      setChartConfig((prevLayout) => ({
        ...prevLayout,
        chart_styles: parsedValue
      }));
      setJsonError("");
    } catch (error) {
      setJsonError(error.message);
    }
  };

  return (
    <div>
      <Textarea
        label="Enter Chat Styles Config"
        value={chartStylesConfig}
        onChange={handleChangePivotConfig}
        error={jsonError}
        rows={20}
      />
    </div>
  );
};

export { EditChartData, EditChartLabel, EditChartStyles };
export default EditChartConfig;
